import { useCallback } from 'react';
import { setRef } from '../helpers/refs';
export const useCombineRefs = (...refCallbacks) => {
  return useCallback(ref => {
    refCallbacks.forEach(refCallback => setRef(refCallback, ref));
  }, refCallbacks);
};